<div id="purchase-sales-graph"></div>

